import { render } from "./AddInfoRemiseModal.vue?vue&type=template&id=504f4b00&scoped=true&ts=true"
import script from "./AddInfoRemiseModal.vue?vue&type=script&lang=ts"
export * from "./AddInfoRemiseModal.vue?vue&type=script&lang=ts"

import "./AddInfoRemiseModal.vue?vue&type=style&index=0&id=504f4b00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504f4b00"]])

export default __exports__